var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningModalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7652",
    "data-name": "Rectangle 7652",
    width: 60,
    height: 60,
    transform: "translate(0 0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17257",
    "data-name": "Group 17257",
    transform: "translate(-1224 -175.098)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(1224 175.098)",
    fill: "#e54e54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Alert",
    transform: "translate(1242 189.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17099",
    "data-name": "Group 17099",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrong_Lyrics",
    "data-name": "Wrong Lyrics",
    transform: "translate(8.272 10.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_15",
    "data-name": "Exclusion 15",
    d: "M9932.231,20028.273h-39.5a3,3,0,0,1-2.579-4.533l19.725-33.135a.172.172,0,0,1,.012-.02.1.1,0,0,0,.013-.025,2.981,2.981,0,0,1,1.795-1.328h.017a.009.009,0,0,1,.009,0,3.008,3.008,0,0,1,.734-.092,3.156,3.156,0,0,1,.884.131,2.926,2.926,0,0,1,1.613,1.213.065.065,0,0,1,.016.02.02.02,0,0,0,0,.012l0,.008a.115.115,0,0,1,.018.027c.008.008.008.008.008.014l.015.023s0,.006.007.01l.008.012,19.719,33.135a3,3,0,0,1-2.522,4.533Zm-19.774-8a1.8,1.8,0,0,0-1.283,3.072,1.78,1.78,0,0,0,1.269.531h.015a1.8,1.8,0,0,0,0-3.6Zm0-20.594a1.5,1.5,0,0,0-1.5,1.5v15.088a1.5,1.5,0,1,0,3,0v-15.088A1.5,1.5,0,0,0,9912.457,19999.678Z",
    transform: "translate(-9889.729 -19989.137)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModalIcon);
export default __webpack_public_path__ + "static/media/warning-modal-icon.13910fd610c16ae6153c0d2684d28497.svg";
export { ForwardRef as ReactComponent };